module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"table\">\n	<div>\n		<div>ТС</div>\n		<div>\n			<control type=\"data-autocomplete\" target=\"parameters.vehicleNum\" bind=\"parameters.vehicleId:id\"\n					 source=\"")
    ; __append(escapeFn( widget.vehiclesDataSourceName ))
    ; __append("\"\n					 column=\"num\" columns=\"num,garagenum\" strict=\"strict\"/>\n		</div>\n\n		<div>С даты</div>\n		<div>\n			<control type=\"datepicker\" target=\"parameters.fromDate\"/>\n		</div>\n\n		<div>По дату</div>\n		<div>\n			<control type=\"datepicker\" target=\"parameters.toDate\"/>\n		</div>\n	</div>\n</div>\n\n<button on-click=\"onCreateClick\" data-format=\"")
    ; __append(escapeFn( Reports.Format.Html ))
    ; __append("\">Создать</button>\n<button on-click=\"onCreateClick\" data-format=\"")
    ; __append(escapeFn( Reports.Format.Excel ))
    ; __append("\">Создать в формате Excel</button>")
  }
  return __output.join("");

}